/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const enableSensitiveDataAsyncRpc = {
  serviceName: 'com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService',
  rpcName: 'enableSensitiveDataAsync',
  auth: 'app',
  fingerprint: '1p0i2oQsSlLgeFnv_5AwVWS5DoaC4JFI',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const disableSensitiveDataAsyncRpc = {
  serviceName: 'com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService',
  rpcName: 'disableSensitiveDataAsync',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADgeFnv_5AwVWS5DoaC4JFI',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSensitiveDataOnboardingOrEnabledRpc = {
  serviceName: 'com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService',
  rpcName: 'getSensitiveDataOnboardingOrEnabled',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACxAVQQlE1SAEmI1ATOYKph',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSensitiveDataSubsettingsRpc = {
  serviceName: 'com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService',
  rpcName: 'getSensitiveDataSubsettings',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAD2H1fq9vE1neJ9y0dcNOkN',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getHipaaEnabledForPortalRpc = {
  serviceName: 'com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService',
  rpcName: 'getHipaaEnabledForPortal',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAl0Bt4jgnZM5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateSubsettingsAsyncRpc = {
  serviceName: 'com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService',
  rpcName: 'updateSubsettingsAsync',
  auth: 'app',
  fingerprint: 'D3ps9tIOdxh1A4yIN-yisG-h3FFx0iPM',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSensitiveDataStateAndSubsettingsForPortalRpc = {
  serviceName: 'com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService',
  rpcName: 'getSensitiveDataStateAndSubsettingsForPortal',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAALH_DkCygQcpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSensitiveDataStateForPortalRpc = {
  serviceName: 'com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService',
  rpcName: 'getSensitiveDataStateForPortal',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABHZ1tQIxw1HWX85kvNcO5P',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPortalDisablementPermittedRpc = {
  serviceName: 'com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService',
  rpcName: 'getPortalDisablementPermitted',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACJh5pZbMMkupwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPortalEligibilityForSensitiveDataRpc = {
  serviceName: 'com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService',
  rpcName: 'getPortalEligibilityForSensitiveData',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABNTFOCHSOKmpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getMaskingOptInRpc = {
  serviceName: 'com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService',
  rpcName: 'getMaskingOptIn',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABIalFj0WOogZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const setMaskingOptInRpc = {
  serviceName: 'com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService',
  rpcName: 'setMaskingOptIn',
  auth: 'app',
  fingerprint: '3jpyaZ_vw8dIalFj0WOogZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getBreezeAccessOptInsRpc = {
  serviceName: 'com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService',
  rpcName: 'getBreezeAccessOptIns',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACRezYBNLdy8UfYJ6S_vksz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const setBreezeAccessOptInRpc = {
  serviceName: 'com.hubspot.sensitive.data.status.controller.rpc.SensitiveDataStatusControllerFrontendService',
  rpcName: 'setBreezeAccessOptIn',
  auth: 'app',
  fingerprint: 'gCEoYvrlG8al5O-fTElgwpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};